import {useMemo} from 'react';
import createResultMotion from './createResultMotion';
import generateConfettiArray from './generateConfettiArray';

export interface ConfettiPortalProps {
  count?: number;
  durationSecs?: number; // in seconds
  delaySecs?: number; // in seconds
}

export default function ConfettiPortal({count = 30, durationSecs, delaySecs}: ConfettiPortalProps) {
  const confettiItems = useMemo(
    () =>
      generateConfettiArray({
        count,
        durationSecs,
        delaySecs,
      }),
    [count, durationSecs, delaySecs],
  );

  return createResultMotion(confettiItems);
}
